/* eslint-disable camelcase */
import React from 'react';
import {
  Formik,
  Field,
} from 'formik';
import {
  useDispatch,
} from 'react-redux';
import {
  Prompt,
} from 'react-router';

import {
  coreActions,
} from '@gymcloud/core';

import {
  history,
} from 'web-history';

import {
  Video,
  Button,
  Author,
  TagList,
  TagField,
  TextField,
  EditorField,
  MarkdownRenderer,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

import * as S from './styled';

type Props = {
  isPro: boolean,
  readOnly: boolean,
  program: any,
  basePath: string,
  resourceType: string,
  onRequestDelete: { (): void },
};

const ProgramTemplates = ({
  isPro,
  readOnly,
  program,
  basePath,
  resourceType,
  onRequestDelete,
}: Props) => {
  let shouldBlockNavigation = false;
  const dispatch = useDispatch();

  const goBack = () => {
    history.push(`${basePath}/${program.id}/overview`);
  };

  const handleUpdate = (payload, actions) => {
    shouldBlockNavigation = false;
    dispatch(
      coreActions.requestUpdateEntity({
        id: program.id,
        payload,
        resourceType,
        callbacks: {
          ...actions,
          onSuccess: goBack,
        },
      }),
    );
  };

  return (
    <Formik
      initialValues={{
        name: program?.name || '',
        tag_list: program?.tag_list ? program.tag_list.join(',') : '',
        description: program?.description || '',
      }}
      onSubmit={handleUpdate}
    >
      {(formProps) => (
        <Flex
          fillSpace
          column
          as="form"
          onKeyPress={() => {
            shouldBlockNavigation = true;
          }}
        >
          <S.Header>
            <Author
              fullName={program?.author_full_name}
            />
            <Flex spacing={15}>
              {isPro && (
                <Button
                  ghost
                  appearance="primary"
                  onClick={() => {
                    if (readOnly) {
                      history.push(`${basePath}/${program.id}/edit`);
                    } else {
                      formProps.submitForm();
                    }
                  }}
                >
                  {readOnly ? 'Edit' : 'Save'}
                </Button>
              )}
              {(resourceType === 'personalPrograms' && readOnly) ? (
                <Button
                  ghost
                  appearance="primary"
                  onClick={() => window.print()}
                >
                  Print
                </Button>
              ) : (
                <Button
                  ghost
                  appearance="danger"
                  onClick={() => {
                    if (readOnly) {
                      onRequestDelete();
                    } else {
                      goBack();
                    }
                  }}
                >
                  {readOnly ? 'Delete' : 'Cancel'}
                </Button>
              )}
            </Flex>
          </S.Header>
          <Flex
            fillSpace
            noScroll
            spacing={30}
            padding="30px"
          >
            <Flex
              column
              width="45%"
              style={{
                minWidth: '450px',
              }}
              noPrint
            >
              <Video
                id={program.video_id}
                src={program.video_url}
                title={program.name}
                entityId={program.id}
                readOnly={readOnly}
                resourceType={resourceType}
                height="350px"
              />
            </Flex>
            {readOnly ? (
              <Flex
                column
                spacing={30}
                padding="0 0 30px 0"
              >
                <S.Title>
                  {program.name}
                </S.Title>

                <MarkdownRenderer
                  source={program?.description}
                  maxHeight={180}
                  placeholder={isPro
                    ? 'Click the Edit button to add a program description'
                    : null}
                />

                <TagList
                  tags={program?.tag_list}
                  resourceType="programs"
                />
              </Flex>
            ) : (
              <Flex
                column
                width="65%"
                spacing={30}
                padding="0 0 30px 0"
              >
                <Field
                  flex="0 0 60px"
                  name="name"
                  label="Name"
                  color="primary"
                  component={TextField}
                />
                <Field
                  rows={6}
                  name="description"
                  label="Description"
                  color="primary"
                  placeholder="Type program description here..."
                  component={EditorField}
                />
                <Field
                  name="tag_list"
                  component={TagField}
                />
              </Flex>
            )}
          </Flex>
          <Prompt
            when={shouldBlockNavigation}
            message="Are you sure you want to leave without saving?"
          />
        </Flex>
      )}
    </Formik>
  );
};

export default ProgramTemplates;
